import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const getCampoTratado = (campo) => {
  if (!campo || campo === 'erro.faturamento') {
    return null;
  }

  const palavras = campo.split('.');
  let campoFormatado = '';
  palavras.forEach((palavra) => {
    if (campoFormatado.length !== 0) {
      campoFormatado += ' ';
    }
    campoFormatado += palavra.charAt(0).toUpperCase() + palavra.slice(1);
  });
  return campoFormatado;
};

const getMensagemErro = (erro, contador) => {
  const campoTratado = getCampoTratado(erro?.campo);
  const mensagem = erro?.mensagem || '';

  if (campoTratado) {
    return `${contador + 1} - ${campoTratado}: ${mensagem}`;
  }

  return `${contador + 1} - ${mensagem}`;
};

const FaturamentoErrosVisualizar = ({ erros, cancelamento, faturamento, emissao }) => {
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} className="mb-16">
          <Typography style={{ fontWeight: 'bold' }}>
            {cancelamento &&
              'Foram retornados alguns erros no processo de cancelamento da Nota Fiscal. Revise as' +
                ' informações abaixo e acione o comando "Cancelar NF" novamente'}
            {faturamento &&
              'Foram retornados alguns erros no processo de faturamento da Nota Fiscal. Revise as informações abaixo e mova' +
                ' os faturamentos para a coluna "Em faturamento" novamente.'}
            {emissao &&
              'Foram retornados alguns erros de transmissão da Nota Fiscal. Revise as informações' +
                ' abaixo reenvie a nota fiscal.'}
          </Typography>
        </Grid>
        {erros !== undefined &&
          erros?.map((erro, contador) => (
            <Grid item xs={12} className="mb-16" id={erro?.id}>
              <Typography>
                {getMensagemErro(erro, contador)}
              </Typography>
            </Grid>
          ))}
      </Grid>
    </>
  );
};

export default FaturamentoErrosVisualizar;
